import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  selectCustomer1: 'Please first',
  selectCustomer2: 'select a Customer',
})
